import React, { useMemo } from "react";
import {
  DEFAULT_RANGE_PRESET_DAYS,
  getRangeFromDays,
  resolveRangePresetValue,
} from "../utils/datePresets";

const DateRangePresetPicker = ({
  label = "Rango de fechas",
  presetLabel = "Rango rapido",
  presetOptionLabel = (days) => `Ultimos ${days} dias`,
  startLabel = "Desde",
  endLabel = "Hasta",
  direction = "past",
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  presetDays = DEFAULT_RANGE_PRESET_DAYS,
  containerClassName = "",
  selectClassName = "border border-gray-300 rounded p-2 w-full",
  inputClassName = "border border-gray-300 rounded p-2 w-full",
  labelClassName = "block text-sm font-medium mb-1",
  inputLabelClassName = "block text-xs text-gray-600 mb-1",
}) => {
  const presetValue = useMemo(
    () => resolveRangePresetValue(startDate, endDate, presetDays, direction),
    [startDate, endDate, presetDays, direction]
  );
  const [showCustomInputs, setShowCustomInputs] = React.useState(false);

  React.useEffect(() => {
    if (presetValue === "custom" && (startDate || endDate)) {
      setShowCustomInputs(true);
    }
  }, [presetValue, startDate, endDate]);

  const handlePresetChange = (value) => {
    if (!value) {
      onStartDateChange?.("");
      onEndDateChange?.("");
      setShowCustomInputs(false);
      return;
    }
    if (value === "custom") {
      setShowCustomInputs(true);
      return;
    }
    const { startDate: nextStart, endDate: nextEnd } = getRangeFromDays(
      value,
      direction
    );
    onStartDateChange?.(nextStart);
    onEndDateChange?.(nextEnd);
    setShowCustomInputs(false);
  };

  return (
    <div className={containerClassName}>
      <label className={labelClassName}>{label}</label>
      <div className="flex flex-col gap-2">
        <div>
          <label className={inputLabelClassName}>{presetLabel}</label>
          <select
            className={selectClassName}
            value={presetValue}
            onChange={(event) => handlePresetChange(event.target.value)}
          >
            <option value="">Seleccionar rango de fechas</option>
            {presetDays.map((days) => (
              <option key={days} value={String(days)}>
                {presetOptionLabel(days)}
              </option>
            ))}
            <option value="custom">Personalizado</option>
          </select>
        </div>
        {showCustomInputs && (
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className={inputLabelClassName}>{startLabel}</label>
              <input
                type="date"
                value={startDate || ""}
                onChange={(event) => onStartDateChange?.(event.target.value)}
                className={inputClassName}
              />
            </div>
            <div>
              <label className={inputLabelClassName}>{endLabel}</label>
              <input
                type="date"
                value={endDate || ""}
                onChange={(event) => onEndDateChange?.(event.target.value)}
                className={inputClassName}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DateRangePresetPicker;
